import { useSelector } from "react-redux"
import Button from "react-bootstrap/Button"
import useT from "utils/hooks/useT"

export default function RunIAPButton({handleClick}) {
  const { t } = useT("common")
  // const dispatch = useDispatch()
  const iapLoading = useSelector((state) => state.waiting.iapLoading)
  
  return (
    <Button
      onClick={() => {
        handleClick()
      }}
      className="run-iap-btn"
    >
      {iapLoading ? ` ${t("processing")}` : t("runIAP")}
    </Button>
  )
}
